import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertOrganizationLetterheadsMutation, InsertOrganizationLetterheadsMutationVariables } from '@/graphql/generated/graphql';
import { InsertOrganizationLetterheadsDocument } from '@/graphql/generated/graphql';
export type OrganizationLetterheadInsertInput = {
  OrganizationIds?: string[]
  FileUrl?: string
  FileKey?: string
  FileName?: string
  FileType?: string
  PageWidth?: number
  PageHeight?: number
  ContentAreaX?: number
  ContentAreaY?: number
  ContentAreaWidth?: number
  ContentAreaHeight?: number
  IsDefault?: boolean
  Name?: string
}

export type InsertOrganizationLetterheadResponse = {
  data: {
    insertOrganizationLetterheads: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertOrganizationLetterhead = () => {
  const mutation = useMutation({
    mutationKey: ['insert-organization-letterhead'],
    mutationFn: (variables: OrganizationLetterheadInsertInput) => {
      return graphqlClient.request<InsertOrganizationLetterheadsMutation>(InsertOrganizationLetterheadsDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertOrganizationLetterhead: mutation.mutate,
    insertOrganizationLetterheadAsync: mutation.mutateAsync,
  }
}

export const INSERT_ORGANIZATION_LETTERHEAD_MUTATION = InsertOrganizationLetterheadsDocument;
